export const backEndApiAddressConfig = 'https://api.dev.system.innowacyjna-delegacja.pl/api/';
export const wnbAddressConfig = 'https://wnb-dev.apps.nexo.zone/';
export const baseAddressWithWnbConfig = 'https://wnb-dev.system.innowacyjna-delegacja.pl';
export const wnbPublicKeyConfig = "-----BEGIN RSA PUBLIC KEY-----\n" +
    "MIIBCgKCAQEAh3KeTBYut50ooPlGZAkzVavPW/dgLBdcl38CHR/FsRTQ1UBtLgB1\n" +
    "XQC5fj+u7kukMV4lNFxFhNKILH9JtHsgyp3cJVIsKQQCETSzUyAndYD5KSCTt48b\n" +
    "uiQhauT/vWTqiWfLflHDwn6t5pwFUI1fA/Ah9K3t6OU0PF6RTLs/QdHw5vZYODOb\n" +
    "5yNp+eksByadKNd1mYQx42zGlbaDj6+/J91rojvudkKK/WDLT27lEDSaeOEGa/Ze\n" +
    "uWuISoOl9NF6zmJW2r85dvs7AlW7KYdXhaDSbP4fj+I0NszOwLOqhMCIlVkb7x+m\n" +
    "WWPGNfI/E84LkRCkow04XFhkr4fdCxv2VQIDAQAB\n" +
    "-----END RSA PUBLIC KEY-----";



//export default 'https://api.alpha.system.innowacyjna-delegacja.pl/spa/api/';
